/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { resourceWithCondition } from '@jira/router-resources__utils/src/resourceWithCondition.tsx';
import { themePreferenceResource } from '@jira/router-resources__theme-preference/src/useThemePreference.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { RouteResource } from '@atlassian/react-resource-router';
import { jiraSpaPageContainerResource } from './jiraSpaPageContainerResource.tsx';

export const jiraSpaResources = (): RouteResource[] => [
	resourceWithCondition(() => fg('jpx-463-spa-relay-query'), jiraSpaPageContainerResource),
	themePreferenceResource,
];
